import NoActiveBooking from './no_active_booking';

export default NoActiveBooking;
